<!-- @format -->

<ng-container *transloco="let t">
  @if (enrolmentPeriodValidity$ | async; as validity) {
    @if (validity === "ONGOING") {
      @if (!isLateEnrolment) {
        <span>
          {{ t("ENROLMENT.ENROLMENT_PERIOD_ENDS", getDateTimeParams(courseUnitRealisation?.enrolmentPeriod?.endDateTime)) }}
        </span>
      }
      @if (isLateEnrolment) {
        <span>
          {{ t("ENROLMENT.LATE_ENROLMENT_PERIOD_ENDS", getDateTimeParams(courseUnitRealisation?.lateEnrolmentEnd)) }}
        </span>
      }
    }
    @if (validity === "PAST") {
      @if (!isLateEnrolment) {
        <span>
          {{ t("ENROLMENT.ENROLMENT_ENDED_DATE", getDateTimeParams(courseUnitRealisation?.enrolmentPeriod?.endDateTime)) }}
        </span>
      }
      @if (isLateEnrolment) {
        <span>
          {{ t("ENROLMENT.LATE_ENROLMENT_ENDED_DATE", getDateTimeParams(courseUnitRealisation?.lateEnrolmentEnd)) }}
        </span>
      }
    }
    @if (validity === "FUTURE") {
      @if (!isLateEnrolment) {
        <span class="d-block">
          {{ t("ENROLMENT.ENROLMENT_PERIOD_STARTS", getDateTimeParams(courseUnitRealisation?.enrolmentPeriod?.startDateTime)) }}
        </span>
        <span class="d-block">
          {{ t("ENROLMENT.ENROLMENT_PERIOD_ENDS", getDateTimeParams(courseUnitRealisation?.enrolmentPeriod?.endDateTime)) }}
        </span>
      }
      @if (isLateEnrolment) {
        <span>
          {{ t("ENROLMENT.LATE_ENROLMENT_PERIOD_NOT_STARTED", getDateTimeParams(courseUnitRealisation?.lateEnrolmentEnd)) }}
        </span>
      }
    }
    @if (validity === "MISSING") {
      <span>
        {{ t("ENROLMENT.NO_ENROLMENT_DATE") }}
      </span>
    }
  }
</ng-container>
